module.exports = __webpack_public_path__ + "img/zh_tw.0a00cf1a.png";